import React, { Component } from 'react';
import { connect } from 'react-redux';
import CollapsibleBox from '../collapsible_box/CollapsibleBox';
import config from '../../config/config';
import './infoBoxes.css';
import TIO_EMILIO_ICON from '../../resources/images/tio-emilio-icon.png';

const SIGN_ICON = 'https://static.retail.autofact.cl/trp/icons/sign-write-purple.svg';
const CHECK_ICON = 'https://static.retail.autofact.cl/trp/icons/check-blue.svg';
const SHIELD_ICON = 'https://static.retail.autofact.cl/trp/icons/autofact-shield-gradient.svg';
const AF_PUBLIC_URL = config.af_public_url;
const SCAM_TIPS_CONTENT_B2B = config.scamTipsContentB2b;
const SCAM_TIPS_CONTENT_B2C = config.scamTipsContentB2c;
const isDirectCustomerServiceCompany = (stepInfo) =>
    Boolean(stepInfo?.company_id && config.directCustomerServiceCompaniesIds.includes(stepInfo.company_id));

class InfoBoxes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeBox: '' // 'requirements' | 'payment' | 'scam' | null cuando se cierra
        };
    }

    handleToggleBox = (boxId) => {
        this.setState((prevState) => ({
            activeBox: prevState.activeBox === boxId ? null : boxId
        }));
    };

    renderPaymentSafetyIntro = (isFinalStep) => (
        <ul className="info-boxes__payment-list">
            <li>
                <strong>
                    Recomendamos no realizar el pago ni la entrega del vehículo hasta que las firmas hayan sido
                    validadas.
                </strong>
            </li>
            <li>
                {isFinalStep
                    ? 'Una vez completadas ambas firmas activaremos seguimiento detallado del proceso. Los estados de revisión y validación se verán así (ejemplo):'
                    : 'Al finalizar el proceso de firma, activaremos el seguimiento detallado del proceso. Los estados de revisión y validación se verán así (ejemplo):'}
            </li>
        </ul>
    );

    renderRequirementsContent = () => {
        const requirements = [
            { text: <><strong>Clave Única:</strong> necesitas tu clave y acceso al correo asociado para el código de seguridad.</> },
            { text: <><strong>Escanearemos tu Cédula por ambos lados:</strong> por lo que debe ser la física y vigente.</> },
            { text: <><strong>Reconocimiento facial:</strong> tu rostro despejado (sin gafas ni gorro) con buena luz y fondo liso.</> },
            { text: <><strong>Validación de Datos:</strong> confirmaremos tu identidad con datos extras.</> },
            { text: <><strong>Firma:</strong> firmarás a mano directo en la pantalla.</> },
            { text: <><strong>Internet estable:</strong> para un proceso exitoso.</> },
        ];

        return (
            <div className="info-boxes__requirements-list">
                {requirements.map((req, index) => (
                    <div className="info-boxes__requirement-item" key={index}>
                        <img src={CHECK_ICON} alt="" className="info-boxes__check-icon" />
                        <span className={req.highlight ? 'info-boxes__text--highlight' : ''}>
                            {req.text}
                        </span>
                    </div>
                ))}
            </div>
        );
    };

    renderStatusBoxes = () => {
        return (
            <>
                {/* Status: Manual Review */}
                <div className="info-boxes__status-box info-boxes__status-box--warning">
                    <div className="info-boxes__status-badge info-boxes__status-badge--warning">
                        <span>Firma en revisión manual</span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="7" stroke="#FF4E04" strokeWidth="1.5"/>
                            <path d="M8 4V8.5L10.5 10" stroke="#FF4E04" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <p className="info-boxes__status-text">
                        <strong>Aún no es recomendable</strong> hacer la entrega y pago porque la firma está en revisión de seguridad.
                    </p>
                </div>

                {/* Status: Verified */}
                <div className="info-boxes__status-box info-boxes__status-box--success">
                    <div className="info-boxes__status-badge info-boxes__status-badge--success">
                        <span>Firma validada digitalmente</span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="7" stroke="#52C41A" strokeWidth="1.5"/>
                            <path d="M5 8L7 10L11 6" stroke="#52C41A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <p className="info-boxes__status-text">
                        <strong>Ahora es más seguro y recomendable</strong> hacer la entrega y pago, las firmas pasaron las revisiones.
                    </p>
                </div>
            </>
        );
    };

    renderPaymentContent = () => {
        return (
            <div className="info-boxes__payment-content">
                {this.renderPaymentSafetyIntro(false)}
                {this.renderStatusBoxes()}
            </div>
        );
    };

    renderScamTipsContent = (showDirectCustomerPaymentBox) => {
        const scamTipsContent = showDirectCustomerPaymentBox ? SCAM_TIPS_CONTENT_B2C : SCAM_TIPS_CONTENT_B2B;
        return (
            <div className="info-boxes__requirements-list">
                {scamTipsContent.map((req, index) => (
                    <div className="info-boxes__requirement-item" key={index}>
                        <img src={CHECK_ICON} alt="" className="info-boxes__check-icon" />
                        <span dangerouslySetInnerHTML={{ __html: `<strong>${req.title}:</strong> ${req.text}` }}>
                        </span>
                    </div>
                ))}
            </div>
        );
    };

    renderFinalTrackingLink = () => {
        const { stepInfo } = this.props;
        const trackingUrl = stepInfo.transferenceRetailCode ? `${AF_PUBLIC_URL}${stepInfo.transferenceRetailCode}` : undefined;
        if (!trackingUrl) {
            return null;
        }
        return (
            <a
                href={trackingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="info-boxes__tracking-button"
            >
                Ir al seguimiento de Transferencia
            </a>
        );
    };

    renderFinalContent = () => {
        return (
            <div className="info-boxes__final-content">
                {this.renderPaymentSafetyIntro(true)}
                {this.renderStatusBoxes()}
                {this.renderFinalTrackingLink()}
            </div>
        );
    };

    renderDirectCustomerPaymentCollapsible = () => {
        const { activeBox } = this.state;
        return (
            <CollapsibleBox
                icon={SHIELD_ICON}
                title="¿Cuándo hacer el pago y la entrega del vehículo?"
                subtitle="Por seguridad, aún no es recomendable"
                isOpen={activeBox === 'payment'}
                onToggle={() => this.handleToggleBox('payment')}
            >
                {this.renderPaymentContent()}
            </CollapsibleBox>
        );
    };

    renderScamTipsCollapsible = (showDirectCustomerPaymentBox) => {
        const { activeBox } = this.state;
        const { identityType } = this.props;
        const showScamTips = !config.excludeSignatureTypesForTips.includes(identityType);
        if (!showScamTips) {
            return null;
        }
        return (
            <CollapsibleBox
                icon={TIO_EMILIO_ICON}
                title="Previene estafas siguiendo los consejos de Tío Emilio"
                isOpen={activeBox === 'scam'}
                onToggle={() => this.handleToggleBox('scam')}
                className="scam-tips-collapsible"
            >
                {this.renderScamTipsContent(showDirectCustomerPaymentBox)}
            </CollapsibleBox>
        );
    };  

    getStepClassName = () => {
        const { step } = this.props;
        const stepClasses = {
            'initial': 'info-boxes-initial',
            'final': 'info-boxes-final'
        };
        return stepClasses[step] || '';
    };

    renderInitialBoxes = (showDirectCustomerPaymentBox) => {
        const { activeBox } = this.state;

        return (
            <>
                <CollapsibleBox
                    icon={SIGN_ICON}
                    title="Acciones y Requisitos para Firmar"
                    isOpen={activeBox === 'requirements'}
                    onToggle={() => this.handleToggleBox('requirements')}
                >
                    {this.renderRequirementsContent()}
                </CollapsibleBox>

                {showDirectCustomerPaymentBox && this.renderDirectCustomerPaymentCollapsible()}

                {this.renderScamTipsCollapsible(showDirectCustomerPaymentBox)}
            </>
        );
    };

    renderFinalBoxes = (showDirectCustomerPaymentBox) => {
        if (showDirectCustomerPaymentBox) {
            return (
                <>
                <CollapsibleBox
                    icon={SHIELD_ICON}
                    title="Próximos pasos y recomendaciones en el pago y la entrega del vehículo"
                    isOpen={true}
                    onToggle={() => {}}
                >
                    {this.renderFinalContent()}
                </CollapsibleBox>
                {this.renderScamTipsCollapsible(showDirectCustomerPaymentBox)}
                </>
            );
        }

        return (
            <>
                {this.renderScamTipsCollapsible(showDirectCustomerPaymentBox)}
            </>
        );
    };

    render() {
        const { stepInfo, step } = this.props;
        const isDirectCustomerService = isDirectCustomerServiceCompany(stepInfo);
        const showDirectCustomerPaymentBox =
            isDirectCustomerService && (step === 'initial' || step === 'final');
        console.log(this.props);
        return (
            <div className={`info-boxes ${this.getStepClassName()}`}>
                {step === 'final'
                    ? this.renderFinalBoxes(showDirectCustomerPaymentBox)
                    : this.renderInitialBoxes(showDirectCustomerPaymentBox)}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo
    };
};

export default connect(mapStateToProps)(InfoBoxes);
